import StandingsBase from "./StandingsBase";

export default function StandingsPro() {
    return (
        <StandingsBase
            scopeType="DRIVER"
            classKey="PRO"
            heading="Meisterschaftswertung"
            pillLabel="PRO"
        />
    );
}
